var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Rate from "antd/es/rate";
import "antd/es/rate/style/index.js";
import { action, observable, makeObservable } from 'mobx';
import React from 'react';
import { observer } from 'mobx-react';
import './AbfragerQuestionRating.css';
import { AvailableTooltip } from '../../../../../components/other/AvailableTooltip';
let MenuPartRating = class MenuPartRating extends React.PureComponent {
    isRatingHovering = false;
    constructor(props) {
        super(props);
        makeObservable(this);
    }
    get questionRating() {
        return this.props.question.questionRating;
    }
    get tooltipTitle() {
        if (this.questionRating.hasRated) {
            return 'Vielen Dank für deine Bewertung!';
        }
        return 'Bewerte diese Frage';
    }
    get stars() {
        if (this.questionRating.hasRated) {
            return (React.createElement(Rate, { character: React.createElement("i", { className: "fas fa-star" }), style: {
                    fontSize: 16
                }, className: "AbfragerQuestionRating AbfragerQuestionRatingRated", value: this.questionRating.givenPoints, disabled: true }));
        }
        return (React.createElement(Rate, { style: {
                fontSize: 16
            }, character: React.createElement("i", { className: "fas fa-star" }), className: "AbfragerQuestionRating", value: this.isRatingHovering ? 0 : this.questionRating.ratingStars, onChange: this.questionRating.rateQuestion, tooltips: ['Mies', 'Hat Mängel', 'Durchschnitt', 'Gut', 'Sehr gut'] }));
    }
    render() {
        const { question } = this.props;
        if (!question)
            return null;
        return (React.createElement("div", { className: "text-warning question_rating", onMouseEnter: action(() => (this.isRatingHovering = true)), onMouseLeave: action(() => (this.isRatingHovering = false)), style: {
                fontSize: 18,
                flex: '0 1 auto',
                marginLeft: 10,
                marginRight: 10,
                height: 45
            } },
            React.createElement(AvailableTooltip, { placement: this.questionRating.hasRated ? 'right' : 'leftTop', title: this.tooltipTitle },
                this.stars,
                React.createElement("div", { style: { fontSize: 11, marginLeft: 2, marginTop: -2, color: '#444444' }, className: "text-muted" },
                    this.questionRating.ratingCount,
                    "\u00A0Bewertung",
                    this.questionRating.ratingCount === 1 ? '' : 'en'))));
    }
};
__decorate([
    observable
], MenuPartRating.prototype, "isRatingHovering", void 0);
MenuPartRating = __decorate([
    observer
], MenuPartRating);
export { MenuPartRating };
